import React, { Fragment, useContext } from "react";
import { Form, Icon } from "@tencent/universe-ui/build/lib";
import { ErrorBoundary } from "react-error-boundary";
import OutputParams from './OutputParams.jsx';
import JsonView from 'react18-json-view'


function RspParams({ type,isLoading, selectRect, detail, image, onSelect, finalResponse,request,response, eduMarkData }) {
  const handleDelParams = ({type,isLoading, selectRect, detail, image, onSelect, eduMarkData}) => {
    try {
      let paramsCon = <></> ;
      switch (type) {
        case 'OpenResult':
          paramsCon = <>
            {
              <ErrorBoundary
              fallbackRender={(error, resetErrorBoundary) => {
                console.log('error', error)
                return (
                  <div></div>
                );
              }}
              onReset={(details) => {
              }}
            >
              <OutputParams
                resultType="OpenResult"
                waitingType="OpenResult"
                isLoading={isLoading}
                onSelect={onSelect}
                selectRect={selectRect}
                showDownload={detail?.resultConfig?.showDownBtn && !image.isExample}
                resultConfig={detail.resultConfig}
                detail={detail}
                request={request}
                params={response}
                eduMarkData={eduMarkData} />
            </ErrorBoundary>
            }</>
          break;
        case 'Result':
          paramsCon = <>
            {
              <ErrorBoundary
              fallbackRender={(error, resetErrorBoundary) => {
                console.log('error', error)
                return (
                  <div></div>
                );
              }}
              onReset={(details) => {
              }}
            >
              <OutputParams
                resultType={detail.resultConfig.type}
                isLoading={isLoading}
                onSelect={onSelect}
                selectRect={selectRect}
                showDownload={detail?.resultConfig?.showDownBtn && !image.isExample}
                resultConfig={detail.resultConfig}
                detail={detail}
                request={request}
                params={response}
                eduMarkData={eduMarkData} />
            </ErrorBoundary>
            }</>
          break;
        case 'Request':
          let _request = JSON.parse(JSON.stringify(request)) ;
          if(!_request.PdfPageNumber){
            delete _request.PdfPageNumber
          }
          paramsCon = <>
            {
              <div className="ocr-code__pre">
                            <JsonView src={_request} keyName={false} theme="winter-is-coming" displayDataTypes={false} />
              </div>
            }
          </>
          break;
        case 'Response':
          paramsCon = <>
            {
              <div className="ocr-code__pre">
                            <JsonView src={finalResponse} keyName={false} theme="default" displayDataTypes={false} />
                          </div>
            }
          </>
          break;
      }
      return paramsCon
    } catch (e) {
      console.log('handleDelParams error',e)
      return <></>
    }

  }
  return (
    <Form layout="horizontal" split>
      { handleDelParams({type,isLoading, selectRect, detail, image, onSelect, eduMarkData})}
    </Form>
  );
}

export default RspParams;

